import { Country } from "./country"
import { Region } from "./region"
import { Timezone } from "./timezone"
import { EicEntry } from "@/types/eic"
import { AgileRegion } from "@/types/agile-region"

export interface Location {
    id?: string | number
    name: string
    coordinates: {
        latitude: string | null
        longitude: string | null
    }
    timezone: string
    countryCode: string
    countryId?: number
    countryName: string
    description?: string
    eicCode: EicEntry | null
    agileRegion: AgileRegion | null
    [key: string]: any
}

export interface Device {
    id: string | number
    name: string
    category: {
        value: string
    }
    [key: string]: any
}

export interface Controller {
    unitIdFormatted: string
    softwareVersion: string
    isConnected: boolean
    [key: string]: any
}

export interface NewLocation {
    name: string
    country: Country | null
    region: Region | null
    timezone: Timezone | null
    ownerId: string | null
    coordinates: { latitude: number | null; longitude: number | null }
}

export type DeviceType = "controller" | "p1-wifi"

export enum RefetchDataType {
    "CONTROLLERS" = "controllers",
    "LOCATIONS" = "locations",
}
